import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { QUICK_PICKUPS } from '../data/quickPickupLocations';

export function useQuickPickups() {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onSnapshot(
      doc(db, 'settings', 'quickPickups'),
      snap => {
        const data = snap.data();
        setLocations(data?.locations?.length > 0 ? data.locations : QUICK_PICKUPS);
        setLoading(false);
      },
      _err => {
        setLocations(QUICK_PICKUPS);
        setLoading(false);
      }
    );
    return unsub;
  }, []);

  return { locations, loading };
}
